import React, { useEffect, useState } from "react";
import Div from "@jumbo/shared/Div";
import {
  Typography,
  Box,
  Grid,
  Tab,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import axios from "axios";
import { BASE_URL } from "app/services/auth-services";
import { DateFormatter } from "app/shared/ReuseComponents/DateFormatter";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";
import HistoryOverview from "app/shared/ReuseComponents/HistoryOverview";
import { FoyerCloseButton } from "app/shared/ReuseComponents/ButtonComponent";

const ViewResignation = ({
  setListResignation,
  setViewResignation,
  currentResignations,
}) => {
  const userDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const partnerId = parseInt(localStorage.getItem("PartnerId"));
  const token = localStorage.getItem("accesstoken");

  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  const [value, setValue] = useState("1");
  const [updateHistory, setUpdateHistory] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState([]);

  useEffect(() => {
    if (!currentResignations?.EmployeeResignation_Id) return;

    // Fetch update history
    axios
      .get(
        `${BASE_URL}/Felix/Updaterecordsfilter/?Partner_Id=${partnerId}&Document_Id=${currentResignations.EmployeeResignation_Id}`,
        header
      )
      .then((res) => setUpdateHistory(res?.data))
      .catch((err) => console.error("Error fetching update history:", err));

    // Fetch approval status
    axios
      .get(
        `${BASE_URL}/Felix/Purchaserequestworkflow/?Request_Id=${currentResignations.EmployeeResignation_Id}`,
        header
      )
      .then((res) => setApprovalStatus(res?.data[0]?.Approve || []))
      .catch((err) => console.error("Error fetching approval status:", err));
  }, [currentResignations?.EmployeeResignation_Id]);

  const handleChange = (event, newValue) => setValue(newValue);

  const handleClose = () => {
    setListResignation(true);
    setViewResignation(false);
  };

  const labels = [
    "Resignation No",
    "Employee Name",
    "Department",
    "Cadre Level",
    "Date of Resignation",
    "Request to Relieve Before",
    "Reason of Leaving",
    "Notice Period (Days)",
    "Relieving Date (HOD)",
    "Relieve Date After Notice Period",
    "Status",
  ];

  const values = [
    currentResignations?.EmployeeResignation_Id || "-",
    currentResignations?.Employee_Name || "-",
    currentResignations?.Department || "-",
    currentResignations?.Cadrelevel || "-",
    currentResignations?.Date_Of_Resignation ? (
      <DateFormatter date={currentResignations.Date_Of_Resignation} />
    ) : (
      "-"
    ),
    currentResignations?.Request_To_Releive_Date ? (
      <DateFormatter date={currentResignations.Request_To_Releive_Date} />
    ) : (
      "-"
    ),
    currentResignations?.Reason || "-",
    currentResignations?.Notice_Period || "0",
    currentResignations?.Releiving_Date && currentResignations?.Approved_Flg ? (
      <DateFormatter date={currentResignations.Releiving_Date} />
    ) : (
      "-"
    ),
    currentResignations?.Releive_Date_After_Noticeperiod &&
    currentResignations?.Approved_Flg ? (
      <DateFormatter date={currentResignations.Releive_Date_After_Noticeperiod} />
    ) : (
      "-"
    ),
    currentResignations?.Approved_Flg
      ? "Approved"
      : currentResignations?.Status
      ? "Rejected"
      : "Pending",
  ];

  // === Status image selection ===
  const getStatusImage = () => {
    if (currentResignations?.Approved_Flg === true && currentResignations?.Status === true)
      return "./../../../../../images/StatusFlg/Approved.png";
    if (currentResignations?.Approved_Flg === false && currentResignations?.Status === true)
      return "./../../../../../images/StatusFlg/Rejected.png";
    return "./../../../../../images/StatusFlg/Pending.png";
  };

  return (
    <Div>
      <Typography variant="h4" sx={{ mb: 1 }}>
        Resignation Overview
      </Typography>

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="Resignation Tabs"
          >
            <Tab label="Overview" value="1" />
            <Tab label="History" value="2" />
          </TabList>
        </Box>

        {/* ============ OVERVIEW TAB ============ */}
        <TabPanel value="1" sx={{ p: { xs: 1, sm: 2 } }}>
          <Box sx={{ position: "relative" }}>
            {/* === Status Image (Top Right Corner) === */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 2,
                p: 1,
              }}
            >
              <img
                src={getStatusImage()}
                width={140}
                height={70}
                alt="Status"
                style={{ objectFit: "contain" }}
              />
            </Box>

            {/* === Resignation Details === */}
            <Grid container spacing={1}>
              {labels.map((label, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={5} sm={4} md={3}>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {label}
                    </Typography>
                  </Grid>
                  <Grid item xs={7} sm={8} md={9}>
                    <Typography variant="body1">: {values[index]}</Typography>
                  </Grid>
                </React.Fragment>
              ))}

              {/* === Workflow Approver Status === */}
              <Grid item xs={12} sx={{ mt: 2 }}>
                <WorkflowApproverStatus
                  WorkflowName="Resignation"
                  approvalStatus={approvalStatus}
                  partnerId={partnerId}
                />
              </Grid>
            </Grid>
          </Box>
        </TabPanel>

        {/* ============ HISTORY TAB ============ */}
        <TabPanel value="2" sx={{ p: { xs: 1, sm: 2 } }}>
          <HistoryOverview
            updatedHistory={updateHistory}
            itemId={"Resignation No"}
          />
        </TabPanel>
      </TabContext>

      {/* === CLOSE BUTTON === */}
      <Div sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
        <FoyerCloseButton onClick={handleClose} />
      </Div>
    </Div>
  );
};

export default ViewResignation;
